import { CommonEnums } from '../../common.enums';

export class TransposeInst {
    transpose_inst_id: number;
    dxMp_Id: number;
    nm: string;
    description: string;
    ver: string;
    transposetype: string;
    delimiter: string;
    valid_Cd: string;
    persistFlg: string;
    updateDt: Date;
    updateBy: string;
    lastUpdateBy: string;
    gen_Tab_Valid_Cd: string;
    prop_Tab_Valid_Cd: string;
    attr_Tab_Valid_Cd: string;

    constructor() {
        this.setDefaults()
    }

    setDefaults() {
        this.transpose_inst_id = CommonEnums.defaults.LONG_VAL;
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.transposetype = CommonEnums.defaults.STRING_EMPTY;
        this.delimiter = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.persistFlg = CommonEnums.defaults.STRING_VAL_YES;
        this.updateDt = new Date();
        this.lastUpdateBy= CommonEnums.defaults.STRING_EMPTY;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.gen_Tab_Valid_Cd = CommonEnums.defaults.SUCCESS_CODE; //Read-Only
        this.prop_Tab_Valid_Cd = CommonEnums.defaults.SUCCESS_CODE; //Read-Only
        this.attr_Tab_Valid_Cd = CommonEnums.defaults.SUCCESS_CODE; //Read-Only
    }

    static parse(transposeInstTmp: TransposeInst): TransposeInst {
        let transposeInst: TransposeInst = new TransposeInst();
        transposeInst.copyFrom(transposeInstTmp);
        return transposeInst;
    }

    copy(): TransposeInst {
        let transposeInstTmp: TransposeInst = new TransposeInst();
        transposeInstTmp.transpose_inst_id = this.transpose_inst_id;
        transposeInstTmp.dxMp_Id = this.dxMp_Id;
        transposeInstTmp.nm = this.nm;
        transposeInstTmp.description = this.description;
        transposeInstTmp.ver = this.ver;
        transposeInstTmp.lastUpdateBy=this.lastUpdateBy;
        transposeInstTmp.transposetype = this.transposetype;
        transposeInstTmp.delimiter = this.delimiter;
        transposeInstTmp.valid_Cd = this.valid_Cd;
        transposeInstTmp.persistFlg = this.persistFlg;
        transposeInstTmp.updateDt = this.updateDt;
        transposeInstTmp.updateBy = this.updateBy;
        transposeInstTmp.gen_Tab_Valid_Cd = this.gen_Tab_Valid_Cd //Read-Only
        transposeInstTmp.prop_Tab_Valid_Cd = this.prop_Tab_Valid_Cd//Read-Only
        transposeInstTmp.attr_Tab_Valid_Cd = this.attr_Tab_Valid_Cd//Read-Only

        return transposeInstTmp;
    }

    copyFrom(transposeInstTmp: TransposeInst): void {
        this.transpose_inst_id = transposeInstTmp.transpose_inst_id;
        this.dxMp_Id = transposeInstTmp.dxMp_Id;
        this.nm = transposeInstTmp.nm;
        this.description = transposeInstTmp.description;
        this.ver = transposeInstTmp.ver;
        this.transposetype = transposeInstTmp.transposetype;
        this.delimiter = transposeInstTmp.delimiter;
        this.valid_Cd = transposeInstTmp.valid_Cd;
        this.updateDt = transposeInstTmp.updateDt;
        this.updateBy = transposeInstTmp.updateBy;
        this.persistFlg=transposeInstTmp.persistFlg;
        this.lastUpdateBy=transposeInstTmp.lastUpdateBy;

        this.gen_Tab_Valid_Cd = transposeInstTmp.gen_Tab_Valid_Cd //Read-Only
        this.prop_Tab_Valid_Cd = transposeInstTmp.prop_Tab_Valid_Cd//Read-Only
        this.attr_Tab_Valid_Cd = transposeInstTmp.attr_Tab_Valid_Cd//Read-Only
    }

    compare(transposeInstTmp: TransposeInst): string {
        let transposeInststring: string = this.toString();
        let transposeInstTmpstring: string = transposeInstTmp.toString();
        if (transposeInststring != transposeInstTmpstring) {
            return transposeInststring + ', ' + transposeInstTmpstring;
        }
        return '';
    }

    toString(): string {
        return "TransposeInst[ transpose_inst_id=" + this.transpose_inst_id +
        "dxMp_Id=" + this.dxMp_Id +
        ",nm=" + this.nm +
        ", description=" + this.description +
        ", ver=" + this.ver +
        ",transposetype=" + this.transposetype +
        ",delimiter=" + this.delimiter +
        ",valid_Cd =" + this.valid_Cd +
        ", persistFlg=" + this.persistFlg +
        ",updateDt=" + this.updateDt +
        ",updateBy=" + this.updateBy +
        ",lastUpdateBy="+ this.lastUpdateBy +
        ",gen_Tab_Valid_Cd =" + this.gen_Tab_Valid_Cd +
        ",prop_Tab_Valid_Cd=" + this.prop_Tab_Valid_Cd +
        ",attr_Tab_Valid_Cd =" + this.attr_Tab_Valid_Cd +
     "]";
    }
}